import Controller from '@ember/controller';
import { ApplicationModel } from 'login/routes/application';

export default class SetPasswordController extends Controller<ApplicationModel> {}
